import { __decorate, __metadata } from "tslib";
import ptDialogAutoMounterManager from '@/services/PtDialogAutoMounterManager';
import { injectable } from 'inversify';
const DefaultPermissionDialog = () => import('./DefaultPermissionDialog.vue');
export { DefaultPermissionDialog };
export const DefaultPermissionDialogServiceSymbol = Symbol.for('DefaultPermissionDialogService');
let DefaultPermissionDialogService = class DefaultPermissionDialogService {
    constructor() {
        ptDialogAutoMounterManager.register(DefaultPermissionDialog);
        this.state = this.getDefState();
    }
    getDefState() {
        return {
            visible: false,
            fieldId: undefined,
        };
    }
    open(fieldId) {
        this.state = {
            ...this.getDefState(),
            visible: true,
            fieldId,
        };
        ptDialogAutoMounterManager.update(DefaultPermissionDialog, {
            ...this.state,
            onCloseHandler: this.close.bind(this),
            onSuccessHandler: this.onSuccess.bind(this),
            vIf: true,
        });
    }
    close() {
        this.state = this.getDefState();
        ptDialogAutoMounterManager.toggleOpenState(DefaultPermissionDialog, false);
    }
    onSuccess() {
        // 处理成功回调
        this.close();
    }
};
DefaultPermissionDialogService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], DefaultPermissionDialogService);
export { DefaultPermissionDialogService };
